import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../../components/Tool'
import { errorCatch, HasRole, LanguageContext, MetaContext, POST, publish, QueryDetail, READWITH } from 'fennec-ui'
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import './index.less';
import { TranslateContext, UserConfigContext, UserContext } from 'fennec-ui';
import { useAuth } from 'fennec-ui';
import {
	Routes,
	Route
} from 'react-router-dom';
import LangSwitchMobile from '../../../components/LangSwitchMobile';
import { LangSwitchContext } from '../../../components/Context';
import CommonProfile from '../../../mobile/pages/CommonProfile';
import ConfigPage from '../../../desktop/pages/ConfigPage';


var _ = require('lodash');

function HomeMobile(props) {
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
			READWITH(auth, 'Translate', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					let o = Object.fromEntries(data.map(i => {
						return [
							i.key,
							{
								ru: i.ru,
								en: i.en,
								es: i.es
							},
						]
					}));
					dispatch(REDUX_Translate.actions.setObject(o));
				}
			}, errorCatch)
			READWITH(auth, 'UserConfig', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					var obj = Object.fromEntries(data.map(i => {
						return [
							i.key,
							i.value
						]
					}));
					dispatch(REDUX_UserConfig.actions.setObject(obj));
				}
			}, errorCatch)
			// auth.openSocket("/ws/service", "service", function (type, payload) {
			// 	if (type === "reload") {
			// 		var href = window.location.href
			// 		window.location.href = href;
			// 	}
			// 	switch (type) {
			// 		case "":
			// 			break;
			// 		default:
			// 			publish("service." + type, payload);
			// 			break;
			// 	}
			// });
			// return () => {
			// 	auth.closeSocket("service");
			// };
		},
		[auth, dispatch]
	);
	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<Routes>
									{(HasRole(user, "root")) && <Route exact path="/root" element={<ConfigPage {...props} />} />}
									<Route index element={<CommonProfile {...props} />} />
									<Route exact path="/common/profile" element={<CommonProfile {...props} />} />
									<Route
										path="*"
										element={
											<main style={{ padding: "1rem" }}>
												<p>{t("Упс. Тут ничего нет!")}</p>
											</main>
										}
									/>
								</Routes>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider >
	);
}
export default HomeMobile;